

export const CombinedPresentation = ({ lang }) => {
  const tours = ['antiguaCity', 'antiguaHobbitenango', 'antiguaLago', 'AntiguaPacaya', 'ChichiPana',];
  return (
    <div className="combined-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/combinedTours/${tour}${lang.charAt(0).toUpperCase() + lang.slice(1)}.jpg`} className={`combined-tour-presentation-img`} alt={tour} key={`${i}-One-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
